import { render, staticRenderFns } from "./GroupVideoList.vue?vue&type=template&id=4c926a0d&scoped=true&"
import script from "./GroupVideoList.vue?vue&type=script&lang=js&"
export * from "./GroupVideoList.vue?vue&type=script&lang=js&"
import style0 from "./GroupVideoList.vue?vue&type=style&index=0&id=4c926a0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c926a0d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VBtn,VLazy})
